import React from 'react'
import classnames from '@utils/classnames'
import Section from '@components/section'
import PartTitle from '@components/partTitle'
import styles from './collect.module.scss'

const Collect = React.memo((props) => {
  return (
    <Section>
      <PartTitle en="PART 04">收集碎片</PartTitle>
      <div className="placeholder">test</div>
      <div className="infoBox">
        <h3>在冒险的同时，你还可以收集更多的位面信息</h3>
        <p>这里是说明文字</p>
      </div>
    </Section>
  )
})

Collect.displayName = 'ArcCollect'
export default Collect